export default __webpack_public_path__ + "static/media/about1_t.3579b378.png";